import * as api from '../_api';

export const read = async ({ commit, dispatch }, { guestId, eventId }) => {
  try {
    const result = await api.read(guestId, eventId);
    commit('setEvent', result.event);
    commit('setGuest', result.guest);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const readQr = async ({ commit, dispatch }, { eventId }) => {
  try {
    const result = await api.readQr(eventId);
    commit('setEvent', result.event);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const accept = async ({ commit, dispatch }, { guestId, eventId, companions }) => {
  try {
    await api.accept(guestId, eventId, companions);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const acceptQr = async ({ commit, dispatch }, { guest, eventId, companions }) => {
  try {
    await api.acceptQr(guest, eventId, companions);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const deny = async ({ commit, dispatch }, { guestId, eventId }) => {
  try {
    await api.deny(guestId, eventId);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};
